module.exports = __webpack_public_path__ + "img/kqzs.5cd5f3c5.png";